import {CognitoConfig, EvidentlyConfig} from './types/config';

export const defaultEvidentlyConfig: EvidentlyConfig = {
    REGION: 'us-east-1',
    ENDPOINT: 'https://evidently.us-east-1.amazonaws.com',
    PROJECT: 'Oneservice_Evidently',
};

export const defaultCognitoConfig: CognitoConfig = {
    COGNITO_POOL_ID: 'us-east-1:1475c9ea-5445-4f35-a77a-5bb9c2c68710',
    // cspell:disable-next-line
    COGNITO_ARN: 'arn:aws:iam::099073702400:role/Platform_EvidentlyUnauth_Role',
    COGNITO_REGION: 'us-east-1',
};
